import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import styles from "./NavBar.module.scss";
import ItemsBlock from "./ItemsBlock";
import MainContainer from "../MainContainer";
import withTheme from "../../libs/themr/withTheme";

let position = 0;

const NavBar = ({ menu, handleLinkClick }) => {
  const [activeBlock, setActiveBlock] = useState(null);
  const [scrollTo, setScrollTo] = useState(null);

  const onScroll = useCallback(() => {
    // eslint-disable-next-line no-undef,no-unused-expressions
    const st = window?.scrollY;
    if (st < position && scrollTo !== "up") {
      setScrollTo("up");
    }
    if (st > position && scrollTo !== "down") {
      setScrollTo("down");
    }
    position = st;
  }, [activeBlock]);

  useEffect(() => {
    // eslint-disable-next-line no-undef,no-unused-expressions
    window.addEventListener("scroll", onScroll);
    return () => {
      // eslint-disable-next-line no-undef,no-unused-expressions
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const handleShowBlock = (el, block) => {
    if (el.menu || block) {
      setActiveBlock(el);
    } else {
      setActiveBlock(null);
    }
  };

  return (
    <div className={styles.navBar}>
      <div className={styles.level1}>
        {menu.map(el => (
          <div
            className={styles.level1Link}
            onMouseEnter={() => handleShowBlock(el)}
            onMouseLeave={() => {
              setActiveBlock(null);
            }}
            role="button"
            tabIndex="0"
            onClick={e => handleLinkClick(e, el.url, el.target, el.isInternalLink)}
            key={el?.id}
          >
            <div className={cn({ [styles.top]: el?.title === activeBlock?.title })} />
            <button
              type="button"
              className={cn(styles.title, { [styles.activeButton]: el?.title === activeBlock?.title })}
            >
              {el.title}
            </button>
            <div className={cn({ [styles.border]: el?.title === activeBlock?.title })} />
          </div>
        ))}
      </div>
      {activeBlock && (
        <div
          onMouseLeave={() => {
            setActiveBlock(null);
          }}
          onMouseEnter={() => handleShowBlock(activeBlock, true)}
          className={cn(styles.block, { [styles.navUp]: scrollTo === "up", [styles.navDown]: scrollTo === "down" })}
        >
          <MainContainer className={styles.mainContent}>
            <ItemsBlock items={activeBlock.menu} handleLinkClick={handleLinkClick} />
          </MainContainer>
        </div>
      )}
    </div>
  );
};

NavBar.propTypes = {
  menu: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      url: PropTypes.string,
      isInternalLink: PropTypes.bool,
      target: PropTypes.string,
      menu: PropTypes.array,
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  ).isRequired,
  handleLinkClick: PropTypes.func.isRequired
};

export default withTheme(styles)(NavBar);
